export enum OfflineTestIds {
  OPEN_OFFLINE_MODAL = 'open-offline-modal',
  DOWNLOAD_DATA_BUTTON = 'download-data-button',
  ENTER_OFFLINE_BUTTON = 'enter-offline-button',
  OPEN_OFFLINE_MODAL_LABEL = 'open-offline-modal-label',
  LEAVE_OFFLINE_BUTTON = 'leave-offline-button',
  CONFIRM_SYNC_OFFLINE_ORDER_BUTTON = 'confirm-sync-offline-order-button',
}
